export default "__VITE_ASSET__e3728cd8__"